package ui.strings

enum class Language(val code: String, val displayName: String) {
    English("en", "English"),
    Japanese("ja", "日本語"),
    SimplifiedChinese("zh-CN", "简体中文"),
    Russian("ru", "Русский"),
    French("fr", "Français")
}
